import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getPayPayPaymentStatus } from "utils/api";
import { Typography, Box } from "@mui/material";
import AppLayout from "works/chi/components/AppLayout";
import StyledButton from "works/chi/components/StyledButton";
import { COLORS } from "constants/colors";

function PayPayPolling() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // クエリパラメータを取得
  const soulId = queryParams.get("soul_id");
  const merchantPaymentId = queryParams.get("merchant_payment_id");

  useEffect(() => {
    let isActive = true; // コンポーネントがマウントされているかを追跡

    const doPolling = async () => {
      while (isActive) {
        try {
          const { status } = await getPayPayPaymentStatus(merchantPaymentId);
          if (status !== "COMPLETED") {
            continue;
          }

          if (soulId.includes("chi_line")) {
            navigate(`/chi/how-to-use?soul_id=${soulId}`);
            return;
          }

          navigate(`/episodes?soul_id=${soulId}`);
          return; // 成功したらループ終了
        } catch (error) {
          console.error("Polling error:", error);
        }

        await new Promise((resolve) => setTimeout(resolve, 3000)); // 3秒間隔で再試行
      }
    };

    doPolling();

    return () => {
      isActive = false; // コンポーネントがアンマウントされたら停止
    };
  }, [merchantPaymentId, soulId, navigate]);

  return (
    <AppLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "18px",
              whiteSpace: "pre-line",
              fontWeight: "bold",
              textAlign: "center",
              color: COLORS.TEXT_BLACK,
              mt: 1,
            }}
          >
            {"購入手続きは\nまだ完了していません"}
          </Typography>

          <Box>
            <Typography
              variant="h4"
              sx={{
                // fontFamily: '"Noto Serif JP", serif',
                fontSize: "15px",
                whiteSpace: "pre-line",
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: "1.8",
                color: "red", // 赤文字
                border: "1px solid red", // 赤枠
                borderRadius: "4px", // 角丸（お好みで調整）
                padding: "8px", // 枠内の余白
                mt: 1,
              }}
            >
              画面を閉じずにお待ちください
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={{
              width: "100%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            }}
            onClick={() => {}}
          >
            購入を完了する
          </StyledButton>
        </Box>
      </Box>
    </AppLayout>
  );
}

export default PayPayPolling;
